import type { ElementType } from "react";

import type { ITextCore } from "../../../../helpers/common/TextCore/types";

export const LIST_VARIANTS_MAP: Record<
    NonNullable<ITextCore["asList"]>,
    ElementType
> = {
    unordered: "ul",
    numbered: "ol",
};
